<template>
  <div style="width: 100%" class="head-span">
    <div class="message">
      <div class="heading-msg">
        <br />
        <span>
          <div class="welcome">
            <span>{{ text.welcome }}</span>
          </div>
          <div>
            <span class="br"
              ><span
                v-for="(part, i) in text.introBeforeFootnote"
                :key="'b' + i"
                :class="{ strong: part.bold }"
                >{{ part.text }}</span
              ><sup class="number">1</sup
              ><span
                v-for="(part, i) in text.introAfterFootnote"
                :key="'a' + i"
                :class="{ strong: part.bold }"
                >{{ part.text }}</span
              ></span
            >
            <span class="br fine-print">{{ text.filterHint }}</span>
            <span class="br fine-print">{{ text.licenseIntro }}</span>
            <span class="br fine-print">
              {{ text.licenseListHeading }}
              <ul class="license-list">
                <li v-for="item in text.licenseList" :key="item">{{ item }}</li>
              </ul>
            </span>
            <span class="home fine-print">{{ text.security }}</span>
          </div>
          <span class="br_1 fine-print">
            {{ text.contact }}
            {{ text.assistanceBeforeForm }}
            <a
              class="inline-link"
              :href="text.urls.requestForm"
              target="_blank"
              >{{ text.requestFormLabel }}</a
            >
            {{ text.assistanceBeforeLocator }}
            <a
              class="inline-link"
              :href="text.urls.resellerLocator || undefined"
              target="_blank"
              >{{ text.resellerLocatorLabel }}</a
            >
            {{ text.assistanceAfterLocator }}
          </span>
        </span>
      </div>
    </div>

    <div class="exportPdf">
      <div class="featuredArea">
        <router-link to="getLinkUrl()">
          <div
            id="moveToAllSolutionsButton"
            class="featured featured--active"
            v-on:click.prevent="allSolution($event)"
          >
            All Solutions
          </div>
        </router-link>
      </div>

      <img
        @click="
          show = 'true';
          changeOrientation('p');
          downloadPdf();
        "
        alt="Export Pdf"
        src="../assets/images/icons/pdf.png"
      />
      <b-modal
        v-model="show"
        title="Your PDF is being downloaded"
        :header-bg-variant="headerBgVariant"
        :header-text-variant="headerTextVariant"
      >
        <template v-slot:modal-footer>
          <div class="w-100" style="display: flex; justify-content: center">
            <b-button
              variant="success"
              size="sm"
              class="float-right btn"
              style="margin: 0 10px"
              @click="show = false"
            >
              Ok
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ApiSvc from "../js/ApiSvc";
import { API, LICENSE_TYPE } from "../js/Constants.js";
import {
  PdfConstants,
  WelcomeText,
  WelcomePdfText,
} from "../js/PdfConstants.js";
import {
  PDF_FONT,
  pdfColor,
  registerPdfFonts,
  loadLogoDataUrl,
} from "../js/pdfAssets.js";

export default {
  name: "export-pdf",
  data() {
    return {
      text: WelcomeText,
      logoDataUrl: null,
      totalItems: 0,
      tableData: [],
      mode: "",
      show: false,
      variants: ["primary", "success"],
      headerBgVariant: "primary",
      headerTextVariant: "light",
      height: 0,
      width: 0,
      filterTypes: {
        country: [],
        brand: [],
        industryType: [],
        solutionType: [],
      },
    };
  },
  props: {
    request: {
      type: Object,
    },
  },
  methods: {
    allSolution(event) {
      event.target.classList.add("featured--active");
      document
        .getElementById("moveToAllSolution")
        .classList.remove("featured--active");
      console.log(event);
      this.$router.push(`/allSolution`);
    },

    downloadPdf() {
      this.request.paging.limit = -1;
      ApiSvc.request(["/appinfolist"], API.POST, this.request)
        .then(async (res) => {
          const { filteredSize } = res.data;
          const { resourceList } = res.data;
          this.totalItems = filteredSize;
          this.tableData = resourceList;
          const doc = new jsPDF(this.mode, "mm", "a4");
          const [, logoDataUrl] = await Promise.all([
            registerPdfFonts(doc),
            loadLogoDataUrl("hpWhite"),
          ]);
          this.logoDataUrl = logoDataUrl;
          doc.setFont(PDF_FONT, "normal");

          if (this.mode === "p") {
            this.firstPageContentPortraitMode(doc);
          }

          doc.text(`Total Results: ${this.totalItems}`, this.width - 50, 30);
          this.createAutoTable(doc);
          this.addHeaders(doc);
          if (this.tableData.length === 0 && this.mode === "p") {
            doc.text(`No data found`, this.width - 130, 70);
          } else if (this.tableData.length === 0 && this.mode === "l") {
            doc.text(`No data found`, this.width - 175, 70);
          }
          this.addFooters(doc);
          doc.save("HPAppsCatalog.pdf");
        })
        .catch(() => this.spinner--);
    },
    addFooters(doc) {
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFont(PDF_FONT, "normal");
      doc.setFontSize(8);
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setDrawColor(...pdfColor("hpBlack"));
        doc.setLineWidth(0.4);
        doc.line(
          10,
          this.height - 57 + 10,
          this.width - 10,
          this.height - 57 + 10
        );
        doc.text(
          "Page " + String(i) + " of " + String(pageCount),
          doc.internal.pageSize.width - 40,
          this.height - 57 + 15
        );
        doc.line(
          10,
          this.height - 57 + 18,
          this.width - 10,
          this.height - 57 + 18
        );
        doc.setFont(PDF_FONT, "normal");
        doc.setFontSize(10);
        let d = new Date();
        doc.text(`Date: ${d.toString()}`, 15, this.height - 57 + 25);
        var text = PdfConstants.footerCopyRight;
        var lines = doc.splitTextToSize(text, this.width - 50);
        doc.text(lines, 15, this.height - 57 + 30);

        doc.addImage(
          this.logoDataUrl,
          "PNG",
          this.width - 30,
          this.height - 57 + 25,
          15,
          15
        );
      }
    },
    addHeaders(doc) {
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFont(PDF_FONT, "bold");
        doc.setFontSize(20);
        doc.text("HP Apps Catalog", 15, 20);
      }
    },
    createAutoTable(doc) {
      let results = [];
      for (let i = 0; i < this.tableData.length; i++) {
        results.push({
          appName: this.tableData[i].name,
          description: this.tableData[i].resourceDetails.description,
          licenseType: LICENSE_TYPE.fromVendor(this.tableData[i].vendorName),
          vendorName: this.tableData[i].vendorName,
        });
      }
      let columns = [
        { title: "App Name", dataKey: "appName" },
        { title: "Description", dataKey: "description" },
        { title: "License type", dataKey: "licenseType" },
        { title: "Vendor Name", dataKey: "vendorName" },
      ];
      doc.autoTable(columns, results, {
        startY: 35,
        headStyles: {
          fillColor: pdfColor("hpPrimary"),
          textColor: pdfColor("hpWhite"),
          lineWidth: 0.2,
          lineColor: pdfColor("hpBlack"),
        },
        theme: "striped",
        tableLineColor: pdfColor("hpBlack"),
        tableLineWidth: 0.2,
        margin: {
          bottom: 50, //this decides how big your footer area will be
          top: 35, //this decides how big your header area will be.
        },
        styles: {
          valign: "middle",
          fontSize: 10,
          font: PDF_FONT,
          minCellHeight: 10,
        },
        bodyStyles: {
          lineWidth: 0.2,
          lineColor: pdfColor("hpBlack"),
        },
        rowPageBreak: "avoid",
        columnStyles: {
          licenseType: { cellWidth: 30 },
        },
      });
    },
    firstPageContentPortraitMode(doc) {
      var lMargin = 15;
      var rMargin = 15;
      this.width = doc.internal.pageSize.getWidth();
      this.height = doc.internal.pageSize.getHeight();
      var bulletIndent = 6;
      var paragraphGap = 5;
      var topY = 35;
      var bottomY = this.height - 57 + 5;
      var y = topY;
      doc.setFont(PDF_FONT, "normal");

      
      var writeBlock = (text, fontSize, indent, gap, links = []) => {
        doc.setFontSize(fontSize);
        var lines = doc.splitTextToSize(
          text,
          this.width - lMargin - rMargin - indent
        );
        var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
        if (y + lines.length * lineHeight > bottomY && y > topY) {
          doc.addPage();
          y = topY;
        }
        if (links.length === 0) {
          doc.text(lines, lMargin + indent, y);
        } else {
          this.writeLinkedLines(doc, lines, links, lMargin + indent, y, lineHeight);
        }
        y += lines.length * lineHeight + gap;
      };

      writeBlock(WelcomePdfText.paragraph1, 15, 0, paragraphGap);
      writeBlock(WelcomePdfText.paragraph2, 12, 0, paragraphGap);
      writeBlock(WelcomePdfText.filterHint, 12, 0, paragraphGap);
      writeBlock(WelcomePdfText.paragraph3, 12, 0, paragraphGap);
      writeBlock(WelcomePdfText.paragraph4, 12, 0, 1);
      WelcomePdfText.bullets.forEach((bullet) => {
        writeBlock("• " + bullet, 12, bulletIndent, 1);
      });
      y += paragraphGap - 1;
      writeBlock(WelcomePdfText.paragraph5, 12, 0, paragraphGap);
      writeBlock(
        WelcomePdfText.paragraph6,
        12,
        0,
        paragraphGap,
        WelcomePdfText.paragraph6Links
      );
      writeBlock(WelcomePdfText.footnote, 10, 0, 0, WelcomePdfText.footnoteLinks);
      doc.addPage();
    },
    writeLinkedLines(doc, lines, links, x, y, lineHeight) {
      const words = [];
      lines.forEach((line, lineIndex) => {
        line.split(" ").forEach((word) => words.push({ word, lineIndex, link: null }));
      });
      links.forEach((link) => {
        const labelWords = link.label.split(" ");
        for (let i = 0; i + labelWords.length <= words.length; i++) {
          if (labelWords.every((w, k) => words[i + k].word === w)) {
            labelWords.forEach((w, k) => (words[i + k].link = link));
          }
        }
      });

      const spaceWidth = doc.getTextWidth(" ");
      for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {
        const lineY = y + lineIndex * lineHeight;
        let cursorX = x;
        const runs = [];
        words
          .filter((w) => w.lineIndex === lineIndex)
          .forEach((w) => {
            const last = runs[runs.length - 1];
            if (last && last.link === w.link) {
              last.text += " " + w.word;
            } else {
              runs.push({ text: w.word, link: w.link });
            }
          });
        runs.forEach((run) => {
          const width = doc.getTextWidth(run.text);
          if (run.link) {
            doc.setTextColor(...pdfColor("hpPrimary"));
            doc.textWithLink(run.text, cursorX, lineY, { url: run.link.url });
            doc.setDrawColor(...pdfColor("hpPrimary"));
            doc.setLineWidth(0.2);
            doc.line(cursorX, lineY + 0.7, cursorX + width, lineY + 0.7);
            doc.setTextColor(0, 0, 0);
          } else {
            doc.text(run.text, cursorX, lineY);
          }
          cursorX += width + spaceWidth;
        });
      }
    },
    changeOrientation(value) {
      this.mode = value;
    },
  },
};
</script>
<style lang="scss" scoped>
.heading-msg {
  width: 60%;
  margin-left: 1.7%;
  font-size: 98%;
  padding: 0px 0px 0px 1px;
  color: $hpBlack;
  text-align: left;
}

.inline-link {
  text-decoration: underline;
}

.license-list {
  margin: 0.25em 0 0 0;
  padding-left: 1.5em;
}

.next-line {
  display: block;
}
.home {
  display: block;
  margin-bottom: 0.5em;
  text-align: justify;
  width: 160%;
}

@media screen and (max-width: 1024px) {
  .next-line {
    display: none;
  }
}

img {
  width: 50px;
  height: 50px;
}
.exportPdf {
  margin-right: 3%;
  margin-bottom: 20px;
  width: fit-content;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 15px;
  margin-top: 20px;
}
.featuredArea {
  display: flex;
}
.featuredArea a {
  color: $hpHighGray;
}
.featuredArea a:hover {
  text-decoration: none;
}

.featuredArea div#moveToAllSolutionsButton {
  padding: 10px 25px;
  border-bottom: 6px solid $hpMediumGray;
  font-size: 20px;
  font-weight: $hpFontWeightMedium;
}

.featuredArea div#moveToAllSolutionsButton.featured--active {
  color: $hpPrimary;
  border-bottom: 6px solid $hpPrimary;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.selected {
  border: solid $hpPrimary 5px;
}

p {
  margin: auto;
}
.btn {
  width: 6rem;
  height: 2rem;
}
.number {
  font-size: 11px;
}
.br {
  display: block;
  margin-bottom: 0.5em;
  line-height: 1.1em;
  text-align: justify;
  width: 160%;
}
.br_1 {
  display: block;
  line-height: 1.1em;
  width: 160%;
}
.welcome {
  margin-bottom: 0.5em;
  font-weight: $hpFontWeightMedium;
}
.strong {
  font-weight: $hpFontWeightMedium;
}
.fine-print {
  font-size: 0.9em;
}
</style>
